import { useT } from '../../i18n/useT'
import { Modal } from '../ui/Modal'
import { Button } from '../ui/Button'

interface LanguageMismatchModalProps {
  isOpen: boolean
  detectedName: string
  confidence: number
  selectedName: string
  onUseDetected: () => void
  onKeepSelected: () => void
  onClose: () => void
}

export function LanguageMismatchModal({
  isOpen,
  detectedName,
  confidence,
  selectedName,
  onUseDetected,
  onKeepSelected,
  onClose,
}: LanguageMismatchModalProps) {
  const t = useT()
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('mismatch.title')}>
      <div className="text-center py-2">
        <div className="w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-warning" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802" />
          </svg>
        </div>
        <p className="text-text-secondary text-sm mb-6">
          {t('mismatch.body', {
            detected: detectedName,
            confidence: Math.round(confidence * 100),
            selected: selectedName,
          })}
        </p>
        <div className="flex gap-3">
          <Button variant="secondary" onClick={onKeepSelected} className="flex-1">
            {t('mismatch.keep', { name: selectedName })}
          </Button>
          <Button onClick={onUseDetected} className="flex-1">
            {t('mismatch.use', { name: detectedName })}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
